import { Card, CardActionArea, CardContent, CardMedia, Grid, Skeleton, Typography } from '@mui/material';
import { Organization } from 'models/organization';
import React, { FC } from 'react';

type CustomerGridItemProps = {
    lab: Organization;
    isSelected: boolean;
    handleLabSelect: (lab: Organization) => void;
};

const CustomerGridItem: FC<CustomerGridItemProps> = ({ lab, isSelected, handleLabSelect }) => {
    return (
        <Grid item xs={12} md={3}>
            <Card
                variant="outlined"
                sx={{
                    height: '100%',
                    backgroundColor: isSelected ? 'calm.light' : 'inherit',

                    borderColor: isSelected ? 'calm.main' : 'grey.500',
                }}
            >
                <CardActionArea
                    onClick={() => handleLabSelect(lab)}
                    data-test={`customer-grid-item.select-lab-${lab._id}`}
                >
                    {lab.logoSignedUrl ? (
                        <CardMedia
                            component="img"
                            height="90"
                            image={lab.logoSignedUrl || '/images/logo-placeholder.png'}
                            sx={{ objectFit: 'contain', padding: 2, backgroundColor: 'white' }}
                        />
                    ) : (
                        <Skeleton variant="rounded" height={90} animation={false} />
                    )}
                    <CardContent sx={{ borderTop: '1px solid #e0e0e0' }}>
                        <Typography
                            gutterBottom
                            variant="subtitle2"
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                textAlign: 'center',
                            }}
                        >
                            {lab.name}
                        </Typography>
                    </CardContent>
                </CardActionArea>
            </Card>
        </Grid>
    );
};

export default CustomerGridItem;
